(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', '../Link', 'prop-types'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('../Link'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.Link, global.propTypes);
    global.Support = mod.exports;
  }
})(this, function (exports, _react, _Link, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _Link2 = _interopRequireDefault(_Link);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Support = function (_React$Component) {
    _inherits(Support, _React$Component);

    function Support() {
      _classCallCheck(this, Support);

      var _this = _possibleConstructorReturn(this, (Support.__proto__ || Object.getPrototypeOf(Support)).call(this));

      _this.state = {
        visible: false
      };
      return _this;
    }

    _createClass(Support, [{
      key: 'renderLinks',
      value: function renderLinks() {
        var styles = {
          color: '#999',
          fontSize: '13px',
          marginRight: '14px',
          padding: '8px 0',
          textDecoration: 'none',
          letterSpacing: '1.2px',
          transition: 'all 0.2s ease-in-out'
        };
        var hoverStyles = {
          color: '#00a9f2'
        };

        return this.props.links.map(function (link, i) {
          if (!link.href) {
            return _react2.default.createElement(
              'span',
              {
                key: i,
                style: styles
              },
              link.text
            );
          }

          return _react2.default.createElement(
            'span',
            { key: i },
            _react2.default.createElement(
              _Link2.default,
              {
                href: link.href,
                style: styles,
                hoverStyles: hoverStyles
              },
              link.text
            )
          );
        });
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          'div',
          {
            className: 'support-section',
            style: {
              padding: '0 0 7px 0'
            }
          },
          this.renderLinks()
        );
      }
    }]);

    return Support;
  }(_react2.default.Component);

  exports.default = Support;
  ;

  Support.propTypes = {
    links: _propTypes2.default.array,
    selector: _propTypes2.default.object,
    selectorText: _propTypes2.default.string,
    modelTitle: _propTypes2.default.string,
    isMobile: _propTypes2.default.bool
  };

  Support.defaultProps = {
    links: []
  };
});